<script>
import moment from 'moment';
import { modalMethods } from '@state/helpers';
import resize from '@utils/image-sizer';

export default {
  components: {},
  props: {
    month: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    thisMonthsPhotos() {
      const newPhotosArray = [];
      this.month.forEach((checkin) => {
        if (checkin.currentMediaAssets.side.url) {
          newPhotosArray.push({
            pos: 'side',
            pic: checkin.currentMediaAssets.side.url,
          });
        }
        if (checkin.currentMediaAssets.back.url) {
          newPhotosArray.push({
            pos: 'back',
            pic: checkin.currentMediaAssets.back.url,
          });
        }
        if (checkin.currentMediaAssets.front.url) {
          newPhotosArray.push({
            pos: 'front',
            pic: checkin.currentMediaAssets.front.url,
          });
        }
      });
      return newPhotosArray;
    },
    thisMonthsDate() {
      return moment(this.month[0].completionDate).format('MMMM YYYY');
    },
    lastUpdatedAt() {
      const dates = this.month.map((checkin) => moment(checkin.completionDate));
      const latestDate = moment.max(dates);
      return moment(latestDate).format('MMM DD, h:mm a');
    },
  },
  mounted() {},
  methods: {
    ...modalMethods,
    onViewPhoto(src, pos) {
      this.setSelectedImage({ src, pos });
      this.$bvModal.show('fullsize-image-modal');
    },
    generateUrl(url) {
      return resize(url, 323, 350);
    },
  },
};
</script>

<template>
  <div class="photo-gallery-wrapper">
    <div class="photo-gallery-header">
      <h4 class="gallery-section-title"
        >{{ thisMonthsDate }}
        <small
          >{{ thisMonthsPhotos.length }} photos, Last updated
          {{ lastUpdatedAt }}</small
        >
      </h4>
    </div>
    <div class="photo-gallery-grid">
      <div
        class="image-thumbnail-container"
        @click="onViewPhoto(photo.pic, photo.pos)"
        v-for="(photo, i) in thisMonthsPhotos"
        :key="`${photo.pic}${i}${photo.pos}`"
      >
        <BaseThumbnail v-if="photo.pic" :image="generateUrl(photo.pic)" />
        <span v-if="photo.pic">{{ photo.pos }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
.image-thumbnail-container {
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  height: 16%;
  margin-bottom: 10px;
  margin-right: 10px;
  position: relative;
  width: 16%;
  &:hover {
    opacity: 0.8;
  }
  span {
    background-color: rgba($color-black-wo-rgb, 0.4);
    bottom: 2%;
    color: white;
    font-family: $base-font-family;
    font-size: 12px;
    font-weight: 800;
    left: 5%;
    letter-spacing: 0.1px;
    line-height: 16px;
    padding: 0.5rem 1rem 0.5rem 1rem;
    position: absolute;
    text-transform: uppercase;
    @media screen and (max-width: 850px) {
      font-size: 8px;
      padding: 0.2rem 0.5rem 0.2rem 0.5rem;
    }
  }
}

.photo-gallery-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 4rem;
  position: relative;

  .photo-gallery-header {
    margin-bottom: 1.5rem;

    .gallery-section-title small {
      color: $color-gray;
      display: block;
      font-weight: 800;
      line-height: 1.3;
    }
  }

  .photo-gallery-grid {
    display: flex;
    flex-wrap: wrap;
  }

  .image-thumbnail {
    border-radius: 8px;
    height: 100%;
    margin: 0 0 0 0;
    overflow: hidden;
    width: 100%;

    ::v-deep img {
      border-radius: $base-border-radius-mini;
      height: 25rem;
      object-fit: cover;
    }
  }
}
</style>
